import {FC} from 'react'
import ViewIntersection from '@app/components/analytics/view-intersection/view-intersection'
import analytics from '../../events'

type Props = {
  children: React.ReactNode
  pauseGame: () => void
}

const TelemetryBottomSheet: FC<Props> = ({children, pauseGame}) => {
  const onBottomSheetVisible = () => {
    analytics.sendOnDominoBottomSheetOpened()
    pauseGame()
  }

  return (
    <ViewIntersection onVisible={onBottomSheetVisible} className='w-full'>
      {children}
    </ViewIntersection>
  )
}

export default TelemetryBottomSheet
